import React, { useState, useEffect, useRef, useContext, Fragment } from 'react'
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Dropdown from 'react-bootstrap/Dropdown';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import ReplyIcon from '@mui/icons-material/Reply';
import Badge from '@mui/material/Badge';
import SendTxt from '../Modals/SendTxt';
import { HeaderModal } from '../../contexts';
import { markCommsProcessed } from '../../common/api';
import { toast } from 'react-toastify';


const CommsAlert = ( { aid, uid, viewing, comms, contacts } ) => {
    const { openModal, closeModal, setModal } = useContext( HeaderModal );

    const [ msgs, setMsgs ] = useState( [] );
    const [ showConvo, setShowConvo ] = useState( false );
    const [ convoCid, setConvoCid ] = useState( '' );
    const [ convo, setConvo ] = useState( { name: '', msgs: [] } );
    const convoRef = useRef( null );

    const NotificationIcon = ( { count } ) => {
        return (
            <Badge badgeContent={count} color="error" sx={ { fontSize: 6 } }>
                <NotificationsNoneIcon />
            </Badge>
        );
    }

    const formatDate = ( date ) => {
        let now = new Date();
        let today = new Date( now.getFullYear(), now.getMonth(), now.getDate() );
        let yesterday = new Date( now.getFullYear(), now.getMonth(), now.getDate() - 1 );
    
        if ( date >= today ) {
            // If the date is today, return the time
            let hours = date.getHours();
            let minutes = date.getMinutes();
            let ampm = hours >= 12 ? 'PM' : 'AM';
            hours = hours % 12;
            hours = hours ? hours : 12; // the hour '0' should be '12'
            minutes = minutes < 10 ? '0'+minutes : minutes;
            let strTime = hours + ':' + minutes + ' ' + ampm;
            return strTime;
        } else if ( date >= yesterday ) {
            // If the date is yesterday, return 'yesterday'
            return "Yesterday";
        } else {
            // If the date is prior to yesterday, return date in 'm/d/yy' format
            let year = date.getFullYear().toString().substr( -2 );
            let month = ( date.getMonth() + 1 ).toString();
            let day = date.getDate().toString();
    
            // Ensure double digit format
            month = month.length === 1 ? '0' + month : month;
            day = day.length === 1 ? '0' + day : day;
    
            return `${month}/${day}/${year}`;
        }
    }
    
    const show = ( e, cid ) => {
        e.stopPropagation();
        setConvoCid( cid );
        setShowConvo( true );
    }

    const handleModal = async ( mt ) => {
        let shouldOpen = true;

        switch ( mt ) {
            case 'sms':
                setModal( <SendTxt close={closeModal} obj={contacts[convoCid]} objType='contact' /> );
                break;

            default:
                console.log( 'Unknown modal type: ' + mt );
                shouldOpen = false;
        }

        if ( shouldOpen ) {
            openModal();
        }
    }

    const markProcessed = async () => {
        const comm = convo.msgs[convo.msgs.length - 1];
        console.log( 'mark as processed: ', comm );
        const resp = await markCommsProcessed( comm.aid, uid, comm.cid );
        if ( resp && resp.length ) {
            toast.success( `The txt thread has been marked as processed.`, { theme: 'dark' } );
        } else {
            toast.error( `Something went wrong while marking the txt thread as processed.`, { theme: 'dark' } )
        }
    }

    useEffect( () => {
        if ( showConvo && convoRef.current ) {
            convoRef.current.scrollTop = convoRef.current.scrollHeight;
        }
    }, [ showConvo, convoRef ] );

    useEffect( () => {
        const yesterday = new Date();
        yesterday.setDate( yesterday.getDate() - 1 );

        if ( comms ) {
            let list = [];
            let show = [];

            Object.keys( comms ).forEach( cid => {
                const comm = comms[cid];

                if ( comm && comm.commType === 'sms' && viewing.includes( comm.aid ) ) {
                    // console.log( 'found an sms: ', comm );
                    const cd = new Date( comm.commDate ? comm.commDate : comm.createdDate );
                    if ( cd.getTime() < ( yesterday.getTime() - ( 1000 * 60 * 60 * 24 * 5 ) ) ) {
                        // console.log( 'it is old - skipping: ' + comm.commDate );
                        return;
                    }
                    // console.log( 'it is recent! ' + comm.commDate );
                    if ( comm.assoc && comm.assoc.length ) {
                        const conid = comm.assoc[0].cid;
                        const c = contacts[conid];
                        if ( c ) {
                            // console.log( 'pushing alert!' );
                            list.push( { 
                                name: c.name, 
                                cid: c.cid, 
                                msg: comm.details, 
                                date: cd, 
                                direction: comm.direction,
                                processed: comm.processed,
                                tstamp: formatDate( cd ) 
                            } );
                        } else {
                            console.log( 'no contact - cannot push alert!!' );
                        }
                    }
                }
            } );

            list.sort( ( a, b ) => {
                return ( b.date.getTime() - a.date.getTime() );
            } );
            const seen = new Set();
            list.forEach( m => {
                if ( !seen.has( m.cid ) ) {
                    seen.add( m.cid );
                    if ( m.direction === 'inbound' && !m.processed ) {
                        show.push( m );
                    }
                }
            } );
            setMsgs( show );
        }
    }, [ comms, contacts, viewing ] );

    useEffect( () => {
        if ( convoCid.length ) {
            const c = contacts[convoCid];
            if ( c ) {
                let obj = {
                    name: c.name,
                    msgs: []
                };

                let list = [];
                Object.keys( comms ).forEach( id => {
                    const comm = comms[id];
                    if ( comm && comm.commType === 'sms' && comm.assoc && comm.assoc.length && comm.assoc[0].cid === convoCid ) {
                        list.push( comm );
                    }
                } );

                list.sort( ( a, b ) => {
                    const ad = new Date( a.commDate ? a.commDate : a.createdDate );
                    const bd = new Date( b.commDate ? b.commDate : b.createdDate);
                    return ( ad.getTime() - bd.getTime() );
                } );

                obj.msgs = [ ...list ];

                console.log( 'obj: ', obj );
                setConvo( obj );
            }
        }
    }, [ convoCid, contacts, comms ] );

    return (
        <Dropdown className='tf-global-msg-list tf-hide-arrow'>
            <Dropdown.Toggle variant='link' className='p-0'>
                <NotificationIcon count={ msgs.length } />
            </Dropdown.Toggle>
            {
                ( showConvo ) ? (
                    <Dropdown.Menu className='tf-global-msg-convo'>
                        <Container>
                            <Row className='tf-global-msg-convo-header align-items-center'>
                                <Col xs='auto' className='tf-global-msg-convo-back p-2' onClick={ () => setShowConvo( false ) }><ArrowBackIosNewIcon /></Col>
                                <Col className='text-center'><Link to={`/contact/${convoCid}`}>{convo.name}</Link></Col>
                                <Col xs='auto'>
                                    <Dropdown className='tf-hide-arrow'>
                                        <Dropdown.Toggle variant='link' className='p-0'>
                                            <MoreHorizIcon />
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu>
                                            <Dropdown.Item onClick={markProcessed}>Mark as Handled</Dropdown.Item>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </Col>
                            </Row>
                            <Row className='tf-global-msg-convo-list overflow-scroll' ref={convoRef}>
                                <Col>
                                    { 
                                        ( convo.msgs.length ) ? (
                                            convo.msgs.map( c => (
                                                <Fragment>
                                                    <Row className='pt-2 pb-1 px-2'>
                                                        <Col className={`tf-global-sms-date ${ ( c.direction === 'inbound' ) ? 'text-start' : 'text-end' }`}>{formatDate( new Date( c.commDate ? c.commDate : c.createdDate ) )}</Col>
                                                    </Row>
                                                    <Row key={c.cid} className='pb-2 px-2'>
                                                        {
                                                            ( c.direction === 'inbound' ) ? (
                                                                <Fragment>
                                                                    <Col xs={10} className='tf-global-sms-received'>{c.details}</Col>
                                                                    <Col xs={2}></Col>
                                                                </Fragment>
                                                            ) : (
                                                                <Fragment>
                                                                    <Col xs={2}></Col>
                                                                    <Col xs={10} className='tf-global-sms-sent'>{c.details}</Col>
                                                                </Fragment>
                                                            )
                                                        }
                                                    </Row>
                                                </Fragment>
                                            ) )
                                        ) : (
                                            <span>No messages shared</span>
                                        )
                                    }
                                </Col>
                            </Row>
                            <Row className='tf-global-msg-convo-footer align-items-center'>
                                <Col className='text-center'><Button variant='link' onClick={ () => handleModal( 'sms' ) }>Send Reply <ReplyIcon /></Button></Col>
                            </Row>
                        </Container>
                    </Dropdown.Menu>
                ) : (
                    ( msgs.length ) ? (
                        <Dropdown.Menu className='tf-global-msg-list-menu overflow-scroll'>
                            {
                                msgs.map( ( m, idx ) => (
                                    <Dropdown.Item key={m.cid} onClick={ ( e ) => show( e, m.cid ) } style={ { borderBottom: '1px solid #eee' } }>
                                        <Row className='pt-2'>
                                            <Col><b>{m.name}</b></Col>
                                            <Col xs='auto'>{m.tstamp}</Col>
                                        </Row>
                                        <Row className='pb-2'>
                                            <Col className='text-wrap'>{m.msg}</Col>
                                        </Row>
                                    </Dropdown.Item>
                                ) )
                            }
                        </Dropdown.Menu>
                    ) : (
                        null
                    )
                )
            }
        </Dropdown>
    )
}


const mapProps = ( state ) =>( {
    aid: state.user.aid,
    uid: state.user.email,
    viewing: state.user.viewing,
    comms: state.comms.byId,
    contacts: state.contacts.byId
} );

const mapDispatch = ( dispatch ) => ( {
    logout: dispatch.user.logout,
} );

export default connect( mapProps, mapDispatch )( CommsAlert );